export const dimensions = {
   sync: "WINDOW_DIMENSIONS_SYNC",
} as const;

export const timelineToggle = {
   setOpen: "TIMELINE_SET_OPEN",
   setFold: "TIMELINE_SET_FOLD",
   toggle: "TIMELINE_TOGGLE",
} as const;
